import type { FaireProductEntity } from "../../entity_types/product";

export const p_yjysw8898k: FaireProductEntity = {
  token: "p_yjysw8898k",
  type: "product",
  name: "The Butter Dish Handmade Ceramic",
  brandToken: "b_d9c679c0",
  brandName: "Pigeon Toe Ceramics & Home Textiles",
  imageUrl:
    "https://cdn.faire.com/fastly/4ca3a2e005eaa7cafae5d0aa5266a87378c548aad1e819cc989821b573333727.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/40593ed7ba92bb81025afca2ba7b2ac7c7f4776abf3e5f4a0fa03506c3ddc16d.jpeg",
    "https://cdn.faire.com/fastly/78d2b9eb2810c4d6842e2e22d2fe54f57480cf17ed5deac2c46e1ece5060fcff.jpeg",
    "https://cdn.faire.com/fastly/e4da55de84c12a5f4f3d599ffe561ecc516c974ea3747df9ed5e42446e1ad2b9.jpeg",
    "https://cdn.faire.com/fastly/86792fad3586192add87427b3654c9a5017778275db9d2fb374452802d623058.jpeg",
    "https://cdn.faire.com/fastly/4b647d2909e5aa617f185a8f21f7c32ccf0525739f951a9c5c0df2dae8462130.jpeg",
    "https://cdn.faire.com/fastly/da47a02fadae0865f21a39d8388cea95ebb3617063937085fcf3f99c719b265d.jpeg",
    "https://cdn.faire.com/fastly/e017dead923adbb9e0f4ced056acb7c8c2e095db97c83261f45b29c4bc14b2ec.jpeg",
    "https://cdn.faire.com/fastly/d499e773b1eaf480fd286c4bcd2a189b58e75b006cb20001fe853cc132268128.jpeg",
  ],
  priceDollars: 42,
  description:
    'Meet The Butter Dish, a collab with our BFFs, Fruitsuper. Designed to fit both western stubbies and elgin butter sizes, this dish is as beautiful as it is functional. As always, our ceramics are hand-crafted in Portland and are both dishwasher and microwave safe. This item is hand-made, so some variance is to be expected.\n\nMaterial: Ceramic\n\nDimensions: 7x3x3.5"',
  tags: [],
  msrpDollars: 84,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:12:59.672Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
